<template>
  <div>
    <v-dialog v-model="dialog.rejected"
      @keydown.esc="dialog.rejected = false"
      :fullscreen="dialog.fullscreen"
      width="750"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#2391d0">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Tolak Ajuan
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#2391d0">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.rejected = false; $emit('close', true);"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>
        
        <v-list 
          color="transparent">
          <v-list-item>
            <v-list-item-avatar
              size="45"
              tile>
              <v-img
                :src="require('@/assets/image/reject.png')"
                style="border-radius: 10px;">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#2391d0">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                class="body-1 font-weight-bold mb-2">
                Input Alasan
              </v-list-item-title>

              <v-list-item-subtitle
                class="font-weight-light">
                Silahkan masukkan alasan penolakan ajuan tersebut.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-card-text
          class="px-4 pb-3 mt-2">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <div
                class="body-2 mb-2">
                <span class="red--text">*</span>
                Alasan Penolakan
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <quill-editor 
                ref="myTextEditor"
                :options="{
                  placeholder: 'Contoh. Lampiran kurang lengkap'
                }"
                v-model="form.note">
              </quill-editor>
              
              <v-alert 
                type="error" 
                text dense prominent 
                class="mt-6"
                v-show="message.error.length > 0"
                v-html="message.error">
              </v-alert>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-2"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            v-on:keyup.enter="save('DITOLAK')"
            @click="save('DITOLAK')"
            :disabled="process.form"
            :loading="process.form"
            color="green"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            @click="dialog.rejected = false; $emit('close', true);"
            :disabled="process.form"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            style="border-radius: 10px;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <section>
      <v-container>
        <v-row
          align="center"
          justify="center">
          <v-col 
            cols="12"
            md="6">
            <v-card
              flat
              class="pa-4 pb-0">
              <v-img
                contain
                class="ma-auto"
                width="150"
                height="150"
                alt="vuetify"
                :src="require('@/assets/image/verified.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#2391d0">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <v-card-text
                class="text-center line-text-second mt-4">
                Jika Anda menyetujui ajuan ini, maka ajuan tersebut akan berstatus <b>DISETUJUI</b>. 
              </v-card-text>

              <v-card-actions>
                <v-btn
                  @click="save('DISETUJUI')"
                  :loading="process.form"
                  :disabled="process.form"
                  block
                  elevation="0"
                  color="green"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  style="border-radius: 10px;">
                  Setujui Ajuan
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col 
            cols="12"
            md="6">
            <v-card
              flat
              class="pa-4 pb-0">
              <v-img
                contain
                class="ma-auto"
                width="150"
                height="150"
                alt="vuetify"
                :src="require('@/assets/image/reject.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#2391d0">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <v-card-text
                class="text-center line-text-second mt-4">
                Jika Anda menolak ajuan ini, silahkan Anda masukkan alasan kenapa Anda menolak ajuan tersebut.
              </v-card-text>

              <v-card-actions>
                <v-btn
                  @click="dialog.rejected = true; $emit('close', false);"
                  :disabled="process.form"
                  block
                  elevation="0"
                  color="red"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  style="border-radius: 10px;">
                  Tolak Ajuan
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          fullscreen: false,
          rejected: false
        },
        form: {
          // APPROVED
          id: '',
          status: '',

          // REJECTED
          note: ''
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted () {
      this.reset()
    },
    methods: {
      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        this.form = {
          id: this.detail.ajuan_id,
          status: '',
          note: ''
        }

        this.process.form = false

        this.message.error = ''
      },
      async save (status) {
        this.message.error = ''

        this.process.form = true

        this.form.status = status

        // SAVE TO REST API
        await post('ajuan/update_status', {
          data: this.form
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.dialog.rejected = false
            
            this.$emit('close', false)
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>